import { FormattedMessage } from "react-intl";

export const booksFirst = [
	{
		img: "./images/books/1.webp",
		stringOne: "The 5 AM Club",
		stringTwo: "Robin Sharma",
	},
	{
		img: "./images/books/2.webp",
		stringOne: "The 5 Habits of Highly Effective People",
		stringTwo: "Stephen R. Covey",
	},
	{
		img: "./images/books/3.webp",
		stringOne: "Four Thousand Weeks",
		stringTwo: "Oliver Burkeman",
	},
	{
		img: "./images/books/4.webp",
		stringOne: "Atomic Habits",
		stringTwo: "James Clear",
	},
	{
		img: "./images/books/5.webp",
		stringOne: "Будь Лучшей Версией Себя",
		stringTwo: "Дэн Вальдшмидт",
	},
	{
		img: "./images/books/6.webp",
		stringOne: "Deep Work",
		stringTwo: "Cal Newport",
	},
	{
		img: "./images/books/7.webp",
		stringOne: "Dopamine Detox",
		stringTwo: "Thibaut Meurisse",
	},
	{
		img: "./images/books/8.webp",
		stringOne: "Essentialism",
		stringTwo: "Greg McKeown",
	},
];

export const booksSecond = [
	{
		img: "./images/books/9.webp",
		stringOne: "The Little Book of Hygge",
		stringTwo: "Meik Wiking",
	},
	{
		img: "./images/books/10.webp",
		stringOne: "Ikigai",
		stringTwo: "Hector Garcia & Francesc Miralles",
	},
	{
		img: "./images/books/11.webp",
		stringOne: "Хочу и Буду",
		stringTwo: "Михаил Лабковский",
	},
	{
		img: "./images/books/12.webp",
		stringOne: "Магия Утра",
		stringTwo: "Хэл Элрод",
	},
	{
		img: "./images/books/13.webp",
		stringOne: "Hierarchy of Needs",
		stringTwo: "Abraham Maslow",
	},
	{
		img: "./images/books/14.webp",
		stringOne: "Думай Медленно... Решай Быстро",
		stringTwo: "Даниэль Канеман",
	},
	{
		img: "./images/books/15.webp",
		stringOne: "The Psychology of Money",
		stringTwo: "Morgan Housel",
	},
	{
		img: "./images/books/16.webp",
		stringOne: "The Power of Now",
		stringTwo: "Eckhart Tolle",
	},
];

export const booksThird = [
	{
		img: "./images/books/17.webp",
		stringOne: "Подсознание Может Всё!",
		stringTwo: "Джон Кехо",
	},
	{
		img: "./images/books/18.webp",
		stringOne: "Просто Будь Собой!",
		stringTwo: "Сара Найт",
	},
	{
		img: "./images/books/19.webp",
		stringOne: "Радикальное Прощение",
		stringTwo: "Колин Типпинг",
	},
	{
		img: "./images/books/20.webp",
		stringOne: "Сила Воли",
		stringTwo: "Келли Макгонигал",
	},
	{
		img: "./images/books/21.webp",
		stringOne: "The Subtle Art of Not Giving A Fuck",
		stringTwo: "Mark Manson",
	},
	{
		img: "./images/books/22.webp",
		stringOne: "The Secret",
		stringTwo: "Rhonda Byrne",
	},
	{
		img: "./images/books/23.webp",
		stringOne: "Поток",
		stringTwo: "Михай Чиксентмихайи",
	},
	{
		img: "./images/books/24.webp",
		stringOne: "Сила Подсознания",
		stringTwo: "Доктор Джо Диспенза",
	},
];
